import { Box, Container, Grid2, Link, Typography } from '@mui/material';

import { Logo } from 'shared/Logo/Logo';
import { useMuiTheme } from 'themes/themeMuiProvider';
import { useTheme } from 'themes/themeProvider';

import styles from './Footer.module.scss';

export const Footer = () => {
  const { theme } = useTheme();
  const { colors } = useMuiTheme();

  const style = {
    '--text-color': theme.footerTextColor,
    '--bg-color': theme.footerColor,
  };

  return (
    <div className={styles.footer} style={style}>
      <Container fixed maxWidth='xl'>
        <Box py={8}>
          <Grid2 container spacing={5} justifyContent='center' alignItems='center'>
            <Grid2 container size={12} justifyContent='center' alignItems='center'>
              <Logo />
            </Grid2>
            {/* <Grid2 container justifyContent='center' alignItems='center'>
              <Typography variant='caption' align='center' color={colors.grayMid}>
                76-78, Rue de Merl
                <br />
                L-2146 Luxembourg
                <br />
                Grand Duchy of Luxembourg
              </Typography>
            </Grid2> */}
            <Grid2 container size={12} justifyContent='center' alignItems='center'>
              <Typography variant='caption'>
                &copy; 2026 &nbsp;
                <Link href='https://duck.energy/' target='_blank' color='primary' rel='noopener'>
                  DuckEnergy
                </Link>
              </Typography>
            </Grid2>
            {/* <Grid2 container size={12} justifyContent='center'>
              <PrivacyPolicy />
            </Grid2> */}
          </Grid2>
        </Box>
      </Container>
    </div>
  );
};
